export const toasts = {
  useChangeShippingMethod: {
    nextOrderMethodChanged: 'Next order shipment method changed successfully',
    subscriptionMethodChanged: 'Subscription shipping method changed successfully'
  },
  commonError: 'Something went wrong. Please try again',
  shippingBillingAddress: {
    errorZipCode: 'Enter a valid postal code',
    errorHtmlTag: 'cannot contain',
    successNextOrder: 'Next order shipping address changed successfully',
    successSubscription: 'Subscription shipping address changed successfully',
    successCheckout: 'Shipping address changed successfully'
  },
  changePaymentMethod: {
    cantRemovePaymentMethod: 'Can not remove payment method: incorrect customerId',
    removedPaymentMethod: 'Payment method removed and changed successfully',
    changedPaymentMethod: 'Payment method changed successfully',
    incorrectId: 'Incorrect orderId'
  },
  orderCreated: 'Order is created',
  migrationToV53: {
    title: 'Your AG1 is Upgraded!',
    description: 'Your subscription is now on the upgraded version of AG1.'
  }
};
